<button
  type="button"
  class="btn btn-ghost-secondary theme-toggle-btn"
  (click)="toggleTheme()"
  [attr.aria-label]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
  title="{{ isDarkMode ? 'Switch to light mode' : 'Switch to dark mode' }}"
>
  <svg
    *ngIf="!isDarkMode"
    cIcon
    name="cilMoon"
    class="theme-icon sun-icon"
    size="lg"
  ></svg>
  <svg
    *ngIf="isDarkMode"
    cIcon
    name="cilSun"
    class="theme-icon moon-icon"
    size="lg"
  ></svg>
</button>
